import { clampVideoFrameTime } from '@/lib/preview/clampVideoFrameTime';

export interface VideoFrameSource {
  videoUrl: string;
  /** Source-video time in seconds. */
  time: number;
  /** Known duration used to clamp capture time. */
  duration?: number | null;
  /** Templates name the second; the editor uses the live playhead. */
  captureLabel?: 'playhead' | 'atTime';
}

export function resolveCaptureTime(source: VideoFrameSource): number {
  return clampVideoFrameTime(source.time, source.duration);
}

export function frameDataUrlToFile(dataUrl: string, time: number): File {
  const [header, payload] = dataUrl.split(',', 2);
  if (!header || !payload || !header.includes(';base64')) {
    throw new Error('Invalid captured frame');
  }
  const mime = header.match(/^data:([^;]+)/)?.[1] ?? 'image/jpeg';
  const binary = atob(payload);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return new File([bytes], `fofoca-frame-${Math.round(time * 1000)}.jpg`, { type: mime });
}
